<apcam-shared-dialog-shell [config]="dialogShellConfig">
    <div class="overflow-hidden h-auto">
        <div>
            {{
                'shared.skeleton.notifications.detailDialog.sentAt' | translate
            }}:
            <strong>{{
                notificationLog.sentAtUtc | translateDate: 'medium'
            }}</strong>
        </div>
        <div class="mb-4 break-words">
            {{
                'shared.skeleton.notifications.detailDialog.message'
                    | translate
            }}:<br /><strong>{{ notificationLog.body }}</strong>
        </div>
    </div>
</apcam-shared-dialog-shell>
